import Box from './Box';

export default Box;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Box/index.ts